<div class="modal-header">
	<!--Title-->
	<h4 class="modal-title pull-left">{{title}}</h4>
	<button type="button" class="close pull-right" aria-label="Close" (click)="newTopicMapbsModalRef.hide()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>

<!--Body-->
<div class="modal-body">
	<form class="px-3" ngNativeValidate>
		<div class="form-group row">
			<label for="topicMapFolderNameLabel">{{ 'NEW_TOPIC_MAP.FOLDER_NAME.NAME' | translate }}</label>
			<input type="text" class="form-control" id="topicMapFolderNameText"
				placeholder="{{ 'NEW_TOPIC_MAP.FOLDER_NAME.PLACEHOLDER' | translate }}" [(ngModel)]="folderName"
				name="folder name" required disabled="true">
		</div>
		<div class="form-group row">
			<label for="topicMapNameLabel">{{ 'NEW_TOPIC_MAP.TOPIC_MAP_NAME.NAME' | translate }}<div
					class="badge-required mx-2"></div></label>
			<input type="text" class="form-control" id="topicMapNameText"
				placeholder="{{ 'NEW_TOPIC_MAP.TOPIC_MAP_NAME.PLACEHOLDER' | translate }}" [(ngModel)]="topicMapName"
				name="topic map name" required>
		</div>
		<div class="form-group row">
			<label for="documentTypeLabel">{{ 'NEW_TOPIC_MAP.DOCUMENT_TYPE.NAME' | translate }}<div
					class="badge-required mx-2"></div></label>
			<input type="text" class="form-control" id="documentTypeText"
				placeholder="{{ 'NEW_TOPIC_MAP.DOCUMENT_TYPE.PLACEHOLDER' | translate }}" [(ngModel)]="documentType"
				(click)="loadDocumentTypes()" name="type name" autocomplete="off" required>
		</div>
		<div class="form-group">
			<label for="attributeLabel">{{ 'NEW_TOPIC_MAP.ATTRIBUTE.NAME' | translate }}</label>
			<div class="alert alert-info" role="alert" *ngIf="!haveProperties">
				No attributes for the selected file
			</div>
			<!--Attribute Table-->
			<div *ngIf="attributeList != undefined">
				<div *ngFor="let attibute of attributeList">
					<div *ngIf="attibute.attributeType != 'null'"> 
					<br>
					<table>
						<th></th>
						<th></th>
						<tr>
							<td width="100">
								<label>{{attibute.attributeName}}
									<sup>
										<i *ngIf="attibute.required=='yes'" class="fa fa-asterisk" aria-hidden="true" style="color:red; font-size:0.6em"></i>
									</sup>
								</label>
							</td>
							<td width="300" >
								<input type="text"  *ngIf="(attibute.attributeType=='Number' || attibute.attributeType=='Text') && (attibute.attributeName != 'Document' && attibute.attributeName != 'c1' && attibute.attributeName != 'System')" 
                #texts name ="attribute" autocomplete="off" [(ngModel)]="attibute.value"  style="width:100%">
								<input type="date"  name ="attribute"  *ngIf="attibute.attributeType == 'Date'" [(ngModel)]="attibute.value"  style="width:100%">
								<div *ngIf= "checkDocument(attibute.attributeType,attibute.attributeName)" >
								<select #options  name ="attribute" [(ngModel)]="attibute.value"   style="width:100%">
									<option *ngFor="let item of attibute.documents" [ngValue]="item.id">
										{{item.documentName}}
									</option>
								</select>
								</div>
								<div *ngIf= "checkComponent(attibute.attributeType,attibute.attributeName)">
									<select  #options  name ="attribute" [(ngModel)]="attibute.value"  style="width:100%" >
										<option *ngFor="let item of attibute.components" [ngValue]="item.id">
											{{item.componentName}}
										</option>
									</select>
									</div>
									<div *ngIf= "checkSystem(attibute.attributeType,attibute.attributeName)" >
										<select  #options  name ="attribute" [(ngModel)]="attibute.value" style="width:100%" >
											<option *ngFor="let item of attibute.systems" [ngValue]="item.systemId">
												{{item.systemName}}
											</option>
										</select>
										</div>
							</td>
						</tr>
					</table>
					</div>
				</div>
			</div>

		</div>
		<div class="form-group row float-right">
			<button type="submit" class="btn btn-primary btn-sm" (click)="onSubmitButtonClick()">Submit</button>
		</div>
	</form>
</div>

<!--Close button-->
<!--<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="newTopicMapbsModalRef.hide()">{{closeBtnName}}</button>
  </div>-->

 